import React from 'react';

const UpdateHomeProducts = () => {
  return <div>hifrom update page</div>;
};

export default UpdateHomeProducts;
